export const projectsData = [
  {
    title: "Distributed Task Queue System",
    description: "Built a high-performance distributed task queue using Redis and Node.js, processing 10K+ tasks/minute with automatic failover and retry mechanisms.",
    tech: ["TypeScript", "Node.js", "Redis", "Docker", "PostgreSQL", "BullMQ"],
    category: "Backend",
    impact: "Reduced job processing time by 60%"
  },
  {
    title: "Microservices E-Commerce Platform",
    description: "Architected and developed a scalable microservices-based e-commerce backend handling 50K+ concurrent users with event-driven architecture.",
    tech: ["TypeScript", "NestJS", "Kafka", "MongoDB", "Kubernetes"],
    category: "Backend",
    impact: "Scaled to handle 5x traffic increase"
  },
  {
    title: "Real-time Analytics Pipeline",
    description: "Designed and implemented a real-time data processing pipeline ingesting 1M+ events/day with stream processing and data aggregation.",
    tech: ["TypeScript", "Kafka", "Redis Streams", "ElasticSearch", "AWS Lambda"],
    category: "Backend",
    impact: "Real-time insights within 2 seconds"
  },
  {
    title: "RESTful API Gateway",
    description: "Created a centralized API gateway with rate limiting, authentication, caching, and request transformation for 20+ microservices.",
    tech: ["TypeScript", "NestJS", "Redis", "Nginx", "JWT"],
    category: "Backend",
    impact: "Improved API response time by 40%"
  },
  {
    title: "Cloud Infrastructure Automation",
    description: "Automated infrastructure deployment and management using IaC principles, reducing deployment time from hours to minutes.",
    tech: ["Terraform", "AWS", "Jenkins", "Docker", "GitHub Actions"],
    category: "DevOps",
    impact: "99.9% uptime achieved"
  },
  {
    title: "GraphQL Federation Layer",
    description: "Implemented a unified GraphQL API layer federating data from multiple REST APIs and databases with optimal query performance.",
    tech: ["TypeScript", "Node.js", "GraphQL", "Apollo Federation", "PostgreSQL"],
    category: "Backend",
    impact: "Reduced client API calls by 70%"
  },
  {
    title: "Full-Stack Project Management Tool",
    description: "Developed an end-to-end project management application with real-time collaboration, task tracking, and team analytics.",
    tech: ["React", "TypeScript", "Node.js", "Socket.io", "MongoDB", "Express"],
    category: "Full Stack",
    impact: "Used by 500+ users daily"
  },
  {
    title: "Database Optimization & Migration",
    description: "Led database performance optimization and migration from SQL to NoSQL, improving query performance and reducing costs.",
    tech: ["PostgreSQL", "MongoDB", "Redis", "TypeScript", "Prisma"],
    category: "Backend",
    impact: "Reduced database costs by 45%"
  },
  {
    title: "Authentication & Authorization Service",
    description: "Built a centralized OAuth2/JWT-based authentication system with role-based access control for enterprise applications.",
    tech: ["TypeScript", "Express", "JWT", "Redis", "PostgreSQL"],
    category: "Backend",
    impact: "Secured 15+ applications"
  },
  {
    title: "CI/CD Pipeline & Monitoring",
    description: "Established comprehensive CI/CD pipelines with automated testing, deployment, and monitoring across multiple environments.",
    tech: ["GitHub Actions", "Docker", "Kubernetes", "Prometheus", "Grafana"],
    category: "DevOps",
    impact: "Deployment frequency increased 10x"
  }
];
